'use strict';

var _ = require('lodash');
var FbcApplicabilityChartTransformerFactory = function FbcApplicabilityChartTransformerFactory(DataTransformer, momentService) {
  function FbcApplicabilityChartTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'fares-mode';
    this.priority = 0;
  }
  FbcApplicabilityChartTransformer.prototype = Object.create(DataTransformer.prototype);
  FbcApplicabilityChartTransformer.constructor = FbcApplicabilityChartTransformer;
  FbcApplicabilityChartTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  FbcApplicabilityChartTransformer.prototype.isCacheable = function () {
    return true;
  };
  FbcApplicabilityChartTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  FbcApplicabilityChartTransformer.prototype.transform = function (data) {
    var faresAppData = data.domain.results;
    var results = [];
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    var length = 0;
    if (faresAppData && faresAppData.length) {
      length = faresAppData.length;
    }
    for (var i = 0; i < length; i++) {
      var entry = faresAppData[i];
      var startDate = memoizedMomentOfDate(entry.applicableDateRangeBegin, momentService.FIELD.APPLICABLE_DATE_RANGE);
      var entDate = memoizedMomentOfDate(entry.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE);
      results.push({
        startDate: startDate,
        endDate: entDate,
        origin: entry.origin,
        destination: entry.destination,
        market: entry.origin + '-' + entry.destination,
        className: entry.className,
        fbc: entry.fareBasisCode,
        fareValue: entry.fare
      });
    }
    return results;
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return FbcApplicabilityChartTransformer;
};
FbcApplicabilityChartTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = FbcApplicabilityChartTransformerFactory;